module.exports = __webpack_public_path__ + "static/media/feedback-graphs.0c252ad8.png";